const searchKeys = {
  getArticleSearch: ({ companyId, url, tab, searchParam, filters }) => [
    'articleSearch',
    companyId,
    url,
    tab,
    searchParam,
    filters,
  ],
  getNovaSearch: ({ url, companyId, tab, searchParam }) => [
    'novaSearch',
    url,
    companyId,
    tab,
    searchParam,
  ],
};

export default searchKeys;
